$(function () {
    var originalContentHeight = null;

    $('.help-link').on('click', function (e) {
        var helpKey = $(this).attr('data-help-key');
        e.preventDefault();

        var documentFrame = $('#documentViewContent');
        if (documentFrame.length === 1) {
            originalContentHeight = documentFrame.height();
            documentFrame.css({'visibility': 'hidden', 'height': '0'});
        }

        $i.dialog({
            width: "70%",
            buttonKeys: {
                'button.close': {
                    classes: 'btn-primary',
                    callback: function () {
                        var documentFrame = $('#documentViewContent');
                        if (documentFrame.length === 1) {
                            documentFrame.css({'visibility': 'visible', 'height': originalContentHeight});
                        }
                        this.destroy();
                    }
                }
            },
            url: $i.contextPath + "/help/help?key=" + encodeURIComponent(helpKey),
            titleKey: 'help.notFound.title',
            load: function (responseText, textStatus, XMLHttpRequest) {
                var title = this.box.find('h1');
                this.box.find('.dialog-head h2').text(title.text());
                title.remove();
            }
        });
    });
});
